import { computed, reactive } from 'vue';

// Which sections of a page the user has folded away, remembered per browser.
// Only the collapsed keys are stored, so a section added later starts visible
// for everyone, including people who already saved a layout.
export default function useCollapsedSections(storageKey) {
  function load() {
    try {
      const parsed = JSON.parse(localStorage.getItem(storageKey) || '[]');
      return Array.isArray(parsed) ? parsed.filter((key) => typeof key === 'string') : [];
    } catch {
      return [];
    }
  }

  const collapsed = reactive(new Set(load()));

  function save() {
    try {
      localStorage.setItem(storageKey, JSON.stringify([...collapsed]));
    } catch {
      // Storage can be unavailable (private window, blocked site data). The
      // choice then simply lasts until the page is reloaded.
    }
  }

  function isCollapsed(key) {
    return collapsed.has(key);
  }

  function toggle(key) {
    if (collapsed.has(key)) {
      collapsed.delete(key);
    } else {
      collapsed.add(key);
    }
    save();
  }

  function expandAll() {
    collapsed.clear();
    save();
  }

  const anyCollapsed = computed(() => collapsed.size > 0);

  return { isCollapsed, toggle, expandAll, anyCollapsed };
}
